export const { PLATFORM, INDEX_PATH, npm_package_version: VERSION, NODE_ENV, GOOGLE_API_KEY, } = process.env;
// коды из спецификации ISO 4217
export const CURRENCIES = [
    'AED',
    'USD',
    'EUR',
    'GBP',
    'RUB',
    'INR',
    'TRY',
    'CNY',
    'CAD',
    'AUD',
    'PKR',
    'ILS',
    'KZT', // Тенге
    'CHF', // Швейцарские франки
    'PLN',
    'UAH',
    'THB',
    'BRL',
    'LKR',
    'MXN', // Мексиканский песо
];
export const LAYOUTS_ORDER = [
    undefined,
    null,
    '',
    'Retail',
    'Ритейл',
    'Office',
    'Офис',
    'Studio',
    'Студия',
    ...Array.from({ length: 30 }, (_, i) => `${i + 1} BR`),
];
export const HEIGHTS_ORDER = [
    undefined,
    null,
    '',
    'Simplex',
    'Duplex',
    'Triplex',
    'Quadruplex',
    'Five Floors',
    'Six Floors',
    'Loft',
];
export const PREFILLED_EN_PROJECT_INFO = `<Тип комплекса>   ←однострочный заголовок (residential complex / villa community и т.д.)

For sale:  ← убрать, если нет
Studio - from ___ AED / ___ sq. ft.
1 BR - from  ___ AED / ___  sq. ft.
2 BR - from ___ AED / ___ sq. ft.
Retail - from ___ AED / ___ sq. ft.

- <feature 1>
- <feature 2>
- <feature 3>   ← перечислять через дефис, с маленькой буквы; если в проекте есть что-то уникальное — выделить это здесь

Payment plan: <XX/YY>     ← если план оплат добавлен к проекту, то его не нужно указывать в описании

EOI: ← обязательно описываем (может быть в AED или в %)
Studio - from ___ AED
1 BR - from ___ AED
Full floor - from ___ AED

Launch date: <Month YYYY>     ← если дата известна
если неизвестно:
The Launch date will be announced later`;
export const PREFILLED_RU_PROJECT_INFO = ` <Тип комплекса>   ← однострочный заголовок (жилой комплекс / комплекс вилл и т.д.)

К продаже:   ← убрать, если нет
Студия - от ___ AED / ___ кв. фт
1 BR - от ___ AED / ___ кв. фт
2 BR - от ___ AED / ___ кв. фт  т
Retail - от ___ AED / ___ кв. фт

- <фича 1>
- <фича 2>
- <фича 3>   ← перечислять через дефис, с маленькой буквы; если в проекте есть что-то уникальное — выделить это здесь

План оплаты: <XX/YY>   ← если план оплат добавлен к проекту, то его не нужно указывать в описании

EOI:   ← обязательно описываем (может быть в AED или в %)
Студия -  от ___ AED
1 BR -  от ___ AED
Целый этаж -  от ___ AED

Дата запуска: <месяц YYYY>   ← если дата известна
если неизвестно:
Дата запуска будет объявлена позже`;
export const COUNTRIES = [
    'AE',
    'TH',
    'MX',
];
